import type { ReactElement, ReactNode } from 'react';

type GapValue = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

// Complete literals: Tailwind emits a utility only if its whole name appears in source.
const GAP = {
  1: 'gap-1',
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  5: 'gap-5',
  6: 'gap-6',
  7: 'gap-7',
  8: 'gap-8'
} as const satisfies Record<GapValue, string>;

export interface StackProps {
  gap?: GapValue;
  children: ReactNode;
  /** Layout utilities only. */
  className?: string;
}

export function Stack({ gap = 4, children, className = '' }: StackProps): ReactElement {
  const gapClass = GAP[gap];
  // border-0 bg-transparent reset covers preflight for non-control elements
  return (
    <div className={`flex flex-col font-ui p-0 border-0 bg-transparent m-0 ${gapClass} ${className}`.trim()}>
      {children}
    </div>
  );
}

export interface RowProps {
  gap?: GapValue;
  children: ReactNode;
  /** Layout utilities only. */
  className?: string;
}

export function Row({ gap = 4, children, className = '' }: RowProps): ReactElement {
  const gapClass = GAP[gap];
  return (
    <div className={`flex flex-row font-ui p-0 border-0 bg-transparent m-0 ${gapClass} ${className}`.trim()}>
      {children}
    </div>
  );
}
